import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { getShops, type MasterDataListResponseData } from '@generated/search-bff';

/**
 * Fetch shop details for multiple master data ids or short ids using the `/api/v1/masterdata/shop` endpoint.
 * Note: The BFF accepts at most 30 shop ids per request.
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/shop/getShopsByIds Search API Documentation}
 */
export async function getShopsByIds(shopIds: string[], apiConfig: ApiConfig): Promise<ApiResult<MasterDataListResponseData>> {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'getShops');

  try {
    // Reason: The BFF accepts at most 30 shop ids per request.
    const shops = await getShops({ data: shopIds.slice(0, 30) }, _apiConfig);

    return {
      status: 'success',
      data: shops.data ?? {},
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
